import React from 'react'
import { Button } from '@driftt/tide-core-legacy'

import ConditionSet from '../ConditionSet'

import './style.styl'

const TargetingDisplayWhen = ({ display, onBackClick, onAddConditionSetClick, isOnFreePlan }) => (
  <div className="playbook-display-when">
    <p className="link playbook-display-when-cancel" onClick={onBackClick}>
      &lt; Display Options
    </p>
    <div className="playbook-title-header">
      <h2>Create your display conditions…</h2>
      <p>Display to visitors when the following conditions are met:</p>
    </div>
    <div>{display.map(conditionSetId => <ConditionSet key={conditionSetId} id={conditionSetId} />)}</div>
    <Button
      onClick={!isOnFreePlan && onAddConditionSetClick}
      disabled={isOnFreePlan}
      className="playbook-targeting-displaywhen-add-condition drift-button drift-button-secondary"
    >
      + Add Condition Set
    </Button>
  </div>
)

export default TargetingDisplayWhen



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplayWhen/component.js